/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { globalBreak } from '@/styles/break';
import { SxProps, Theme } from '@mui/material';

export const productCardMediaSX: SxProps<Theme> = {
	//mt: 2,
	mb: 1,
	mx: 'auto',
	backgroundSize: 'contain',
	position: 'relative',
	height: (theme) => theme.dimensions.productCard.thumbnail + 'px',
	minHeight:globalBreak({mobile:'unset', desktop:165})
};

export const productCardRibbonSX:SxProps= {
	position:'absolute',
	top:8,
	zIndex:1,
	'& img':{
		maxHeight:30,
		marginLeft:'-16px',
	}
};